/** Work-screen landing per role: partners land straight on their work screen. */
export const roleHome = (role) => {
  if (role === "restaurant") return "/dashboard/restaurant";
  if (role === "restaurant_group") return "/dashboard/groupe";
  if (role === "driver") return "/driver";
  if (role === "admin") return "/admin";
  return "/";
};
